export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13281.0ccee50d.jpg";